import React, { useEffect } from 'react';
import { Paper} from '@material-ui/core';
import { LessorProfile } from '../components';
import { checkPermission } from '../../utils_v2';
import ConfigSideNav from '../components/ConfigSideNav';
import { browserHistory } from 'react-router';
import DeploymentMessage from '../../../shared/components/DeploymentMessage';
const LessorConfig = ({ }) => {
    useEffect(() => {
        if (checkPermission('console', 'lessor_configuration', 'R')) {
            return
        } else if (checkPermission('console', 'introduction', 'R')) {
            return browserHistory.push('/configure/introduction')
        } else if (checkPermission('console', '3rd_party_integration', 'R')) {
            return browserHistory.push('/configure/third-party-integration')
        }  else {
            return
        }
    }, [])
    
    return (
        <section className='config-container' style={{ margin: '24px 0 0 75px' }}>
        <DeploymentMessage />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ minHeight: `${window.innerHeight - 82}px` }}>
                <ConfigSideNav />
                {checkPermission('console', 'lessor_configuration', 'R') ?
                    <div className="tech-specs-content">
                        <Paper elevation={0} className='console-paper' style={{ marginBottom: '15px', padding: '15px' }}>
                            <LessorProfile />
                        </Paper>
                    </div>
                    : null
                }
            </Paper>
        </section>
    )
}
export default LessorConfig;